import { Box, Text } from "@chakra-ui/react";
import LineGraph from "../LineGraph";
import ReportDataTable from "../reports/ReportDataTable";
import { ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS } from "../../store/renderConfig";
import { getArrivalRatesPerServiceRowsForScope } from "../../store/arrivalRatesPerServiceExport";
import { renderArrivalRatesPerServiceCell } from "../branches/tables/BranchServicesTable";

const ServiceArrivalRatesTable = ({
  index,
  serviceData,
  renderConfig,
  onRenderConfigChange,

}) => {
  const {
    total,
    serviceName,
    hasData,
    chart
  } = serviceData;
  const heading = `${serviceName}`;
  const title = `${index + 1}. ${heading}`;
  
  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="arrivalRatesPerServiceBlock" mt="20px" mb="32px">
        <ReportDataTable
          columns={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
          rows={getArrivalRatesPerServiceRowsForScope({
            data: [serviceData],
            scope: "Organization",
          }, renderConfig)}
          renderConfig={renderConfig}
          renderCell={renderArrivalRatesPerServiceCell}
          presortedRows={true}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }

  return (
    <Box key={index} className="reportContainer arrivalRatesPerServiceChartBlock" mt="20px">
      <h3>
        {title}
        {!hasData && (
          <Text fontSize="sm">No data available for this report</Text>
        )}
      </h3>

      <Box>
        {total ? (
          <Box mt="16px" mb="20px">
            <LineGraph
              chart={chart}
              height={"220px"}
              title={`Entire Organization: ${serviceName} Arrival Rates, Day by Day Comparison`}
            />
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default ServiceArrivalRatesTable;
